var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 909 254",
    width: 909,
    height: 254,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BRD REbranding 2024 - Logo FINAL-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m68.7 130.7c17.2-55.2 55.4-98.1 103-122.7-71.4 14.9-132.9 67-156.2 141.5-10.4 33.5-12 67.6-5.9 99.9h57.5c-10.7-37.6-10.9-78.6 1.6-118.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m310.3 165c-19.7-63-71.6-107-132-119.6 40.3 20.8 72.5 57 87.1 103.7 10.6 33.9 10.3 68.5 1.3 100.3h48.6c5.1-27.3 3.8-56.1-5-84.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m351.8 4.9h40v244.4h-40zm20.1 206.4h72.1q21 0 31.3-8.8 10.2-8.8 10.2-24.6v-0.5q0-10.9-4-18.7-4-7.7-12.4-11.8-8.4-4.1-20.9-4.1h-76.3v-37.7h76.3q16.7 0 25.4-8.1 8.7-8 8.8-23.3-0.1-15.2-9.3-23-9.2-7.8-27.2-7.8h-74v-38h77.8q23.7 0 40.1 8 16.4 8 24.7 22.8 8.4 14.8 8.4 35.5 0 13.4-5.3 24.4-5.3 11-15.7 18.4-10.3 7.4-25.3 10.1 15.5 2.2 26.6 10.2 11.1 8 17 20.3 5.9 12.4 5.9 27.7v0.5q0 20.3-8.9 35.3-8.8 15.1-25.4 23.2-16.5 8-39.2 8h-80.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m539.5 4.8h40.2v244.5h-40.2zm16.7 105.2h84.2q8.4 0 14.9-4.1 6.4-4.1 10-11.7 3.5-7.5 3.7-17.6 0-9.9-3.6-17.5-3.5-7.5-10-11.7-6.4-4.1-15-4.1h-84.2v-38.5h85.4q20.6 0 36.3 8.9 15.6 8.9 24.3 25.3 8.6 16.3 8.6 37.6 0 21.5-8.6 37.8-8.7 16.3-24.4 25.2-15.7 8.9-36.2 8.9h-85.4zm59 31l41.7-7.8 64.2 116.2h-48.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m729.5 3.9h40.2v244.4h-40.2zm23.2 205.9h57q24.8 0 38.5-12.4 13.7-12.4 13.7-35.3v-71.9q0-22.9-13.7-35.3-13.7-12.5-38.5-12.5h-57v-38.5h56q29.9 0 51.1 10.3 21.3 10.2 32.4 29.9 11.1 19.7 11.1 47.4v69.2q0 27.1-10.9 46.8-11 19.6-32.2 30.2-21.3 10.6-51.7 10.6h-55.8z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrd);
export default __webpack_public_path__ + "static/media/brd.5755998766505a6618295576bdfec8b2.svg";
export { ForwardRef as ReactComponent };